import axios from 'axios';
import { axiosConfig, ThrowErrorMsg } from '../util';

import {
  GET_ADDRESSES_PAGINATED,
  GET_ADDRESS,
  UPDATE_ADDRESS,
  ADD_ADDRESS,
  DELETE_ADDRESS,
} from '../types';

const basePath = `${process.env.REACT_APP_API_URL}/v1`;

export const addAddress = (data) => async (dispatch) => {
  const body = JSON.stringify(data);
  try {
    const res = await axios.post(`${basePath}/address`, body, axiosConfig);
    dispatch({ type: ADD_ADDRESS, payload: res.data });

    return res;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const getAddress = (postalCode) => async (dispatch) => {
  try {
    const res = await axios.get(`${basePath}/address/${postalCode}`);
    dispatch({ type: GET_ADDRESS });
    return res;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const updateAddress = (data, id) => async (dispatch) => {
  const body = JSON.stringify(data);
  try {
    const res = await axios.put(`${basePath}/address/${id}`, body, axiosConfig);
    dispatch({ type: UPDATE_ADDRESS, payload: res.data });
    return res;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const getPaginatedAddresses = (query) => async (dispatch) => {
  try {
    const params = {
      ...query,
      pageNo: query.page,
    };

    const res = await axios.get(`${basePath}/addresses`, { params });

    dispatch({
      type:    GET_ADDRESSES_PAGINATED,
      payload: res.data,
    });

    return res.data;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const deleteAddress = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(`${basePath}/address/${id}`);

    dispatch({
      type:    DELETE_ADDRESS,
      payload: id,
    });

    return res;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};
